import React, { useState } from 'react'
import './FAQ.scss'
import { Accordion, Row, Col, useAccordionButton } from 'react-bootstrap'
import { SlArrowDown as Plus } from 'react-icons/sl'
import GradientUnderline from '../../../Components/GradientUnderline/GradientUnderline'

const QUESTIONS = [
  {
    eventKey: 0,
    id: 'q1',
    question: 'How do I purchase a #GlobalZiXXar event ticket?',
    answer: (
      <>
        You can get one of the three available tickets, Premium VIP, VIP, or
        General Access, in the{' '}
        <a href='https://shop.zixxar.net/shop?category=Tickets' target='_blank'>
          ZiXXar shop
        </a>
        .
      </>
    ),
  },
  {
    eventKey: 1,
    id: 'q2',
    question: 'What is included in the Premium VIP ticket?',
    answer: (
      <>
        The Premium VIP ticket offers the following features:
        <ul>
          <li>
            Access to the Meet & Greet cocktail party on the evening of December
            1st
          </li>
          <li>Premium seating at the event on December 2nd and 3rd</li>
          <li>
            Access to the Afterparty dinner on the evening of December 3rd
          </li>
          <li>Reimbursement for flight and hotel up to $700</li>
          <li>Free Souvenir Gift</li>
        </ul>
      </>
    ),
  },
  {
    eventKey: 2,
    id: 'q3',
    question: 'What is included in the VIP ticket?',
    answer: (
      <>
        The VIP ticket offers the following features:
        <ul>
          <li>
            Access to the Meet & Greet cocktail party on the evening of December
            1st
          </li>
          <li>VIP seating at the event on December 2nd and 3rd</li>
          <li>
            Access to the Afterparty dinner on the evening of December 3rd
          </li>
          <li>Reimbursement for hotel up to $250</li>
          <li>Free Souvenir Gift</li>
        </ul>
      </>
    ),
  },
  {
    eventKey: 3,
    id: 'q4',
    question: 'What is included in the General Access ticket?',
    answer: (
      <>
        The General Access ticket offers the following features:
        <ul>
          <li>Event access on December 2nd and 3rd</li>
          <li>
            Access to the Afterparty dinner on the evening of December 3rd
          </li>
        </ul>
      </>
    ),
  },
  {
    eventKey: 33,
    id: 'q33',
    question: 'How do I confirm my participation at the #GlobalZiXXar event?',
    answer: (
      <span>
        The first step for confirmation is to CLAIM your ticket in your
        inventory. The next step is to answer the email you will receive from
        office@zixxar.net in which you may be asked to provide additional
        information.
      </span>
    ),
  },
  {
    eventKey: 4,
    id: 'q5',
    question: 'What information is used to claim my ticket?',
    answer:
      'Your Profile Information is what is used to automatically populate your ticket when you press CLAIM.',
  },
  {
    eventKey: 5,
    id: 'q6',
    question: 'Can I exchange my ticket?',
    answer: (
      <>
        After claiming your ticket there are 2 ticket exchange options:
        <ol>
          <li>
            If your visa has been rejected and you upload the necessary
            documents, you can exchange your ticket for a ticket to the next
            main ZiXXar event that will be announced on December 3rd in
            Barcelona.
          </li>
          <li>
            You can choose to exchange your ticket for a 1,400 USDT Value Card.
          </li>
        </ol>
      </>
    ),
  },
  {
    eventKey: 6,
    id: 'q7',
    question: 'What is the deadline to claim my ticket?',
    answer: 'The CLAIM deadline is November 15, 2023.',
  },
  {
    eventKey: 7,
    id: 'q8',
    question: "Can I participate at the event if I haven't claimed my ticket?",
    answer: 'No.',
  },
]

function CustomToggle({ children, eventKey, activeId, setId, setActiveId }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    setActiveId(activeId === setId ? '' : setId)
  )

  return (
    <span className='custom-toggle' onClick={decoratedOnClick}>
      {children}
    </span>
  )
}

const FAQ = () => {
  const [activeId, setActiveId] = useState('q1')

  return (
    <div id='event-faq' className='section-margins'>
      <div className='large-container d-flex align-items-start justify-content-start flex-column gap-5'>
        <div className='d-flex align-items-start justify-content-start flex-column gap-2 w-100'>
          <h2 className='font-pnb font-size-64'>FAQ.</h2>
          <GradientUnderline />
          <span className='font-size-18 font-pnr color-light-grey'>
            Our comprehensive FAQ section is here to help
          </span>
        </div>

        <Accordion className='dark-grey-color w-100' defaultActiveKey='0'>
          <Row xs={1} sm={1} md={1} lg={1} xl={2}>
            <Col>
              {QUESTIONS.slice(0, QUESTIONS.length / 2).map((el, index) => {
                return (
                  <Accordion.Item
                    eventKey={el.eventKey}
                    key={el.id}
                    id={`${activeId === el.id ? 'active-item' : ''}`}
                  >
                    <Accordion.Header className=' white-color font-pnsb mb-10px '>
                      <CustomToggle
                        eventKey={`${index}`}
                        activeId={activeId}
                        setId={el.id}
                        setActiveId={setActiveId}
                      >
                        <div className='white-color font-size-24 font-pnsb mb-10px large-container w-100 d-flex align-items-center justify-content-between gap-2'>
                          {el.question}
                          <div>
                            <Plus className='button-transition' />
                          </div>
                        </div>{' '}
                      </CustomToggle>
                    </Accordion.Header>

                    <Accordion.Body>
                      <div className='large-container font-pnr font-size-18 line-height-18  white-color'>
                        {el.answer}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                )
              })}
            </Col>
            <Col>
              {QUESTIONS.slice(QUESTIONS.length / 2).map((el, index) => {
                return (
                  <Accordion.Item
                    eventKey={el.eventKey}
                    key={el.id}
                    id={`${activeId === el.id ? 'active-item' : ''}`}
                  >
                    <Accordion.Header className=' white-color font-pnsb mb-10px '>
                      <CustomToggle
                        eventKey={`${index}`}
                        activeId={activeId}
                        setId={el.id}
                        setActiveId={setActiveId}
                      >
                        <div className='white-color font-size-24 font-pnsb mb-10px large-container w-100 d-flex align-items-center justify-content-between '>
                          {el.question}
                          <div>
                            <Plus className='button-transition' />
                          </div>
                        </div>{' '}
                      </CustomToggle>
                    </Accordion.Header>

                    <Accordion.Body>
                      <div className='large-container font-pnr font-size-18 line-height-18  white-color'>
                        {el.answer}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                )
              })}
            </Col>
          </Row>
        </Accordion>
      </div>
    </div>
  )
}

export default FAQ
